import { Button } from '@talentmesh/ui/components/button';
import { Spinner } from '@talentmesh/ui/components/spinner';
import useResendEmailPanelState from '../Utils/useResendEmailPanelState';
import UIStrings from '@/Utils/UIStrings';

function ResendEmailPanel() {
    const { resendHandler, resendButtonLoading } = useResendEmailPanelState();

    return (
        <div className="flex flex-col items-start p-2">
            <p className="text-sm">{UIStrings.DontSeeEmailInSpamJunkFolder}</p>
            <Button
                type="button"
                variant="default"
                size="sm"
                className="h-8"
                onClick={resendHandler}
                disabled={resendButtonLoading}
            >
                {resendButtonLoading && <Spinner data-icon="inline-start" className="animate-spin" />}
                {UIStrings.ResendEmail}
            </Button>
        </div>
    );
}

export default ResendEmailPanel;
